document.addEventListener('DOMContentLoaded', function() {
  const forms = document.querySelectorAll('.product-card-detailed__quantity-form');
  forms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const submitButton = form.querySelector('button[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
      }
      
      try {
        const formData = new FormData(form);
        
        // Add the item to the cart
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: formData.get('id'),
              quantity: parseInt(formData.get('quantity'))
            }]
          })
        });
        
        if (!response.ok) throw new Error('Network response was not ok');
        
        // Parse the response
        const result = await response.json();
        
        // Get the cart drawer and trigger refresh
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          // Dispatch refresh event to trigger the proper cart update flow
          setTimeout(() => {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }, 300);
          
          // Brief delay to ensure cart is refreshed before opening
          setTimeout(() => {
            if (!cartDrawer.classList.contains('active')) {
              cartDrawer.classList.add('active');
              document.body.classList.add('overflow-hidden');
            }
          }, 500);
        }
        
        // Update button text to show success
        if (submitButton) {
          const originalText = submitButton.textContent;
          submitButton.textContent = 'ADDED!';
          setTimeout(() => {
            submitButton.textContent = originalText;
            submitButton.disabled = false;
          }, 2000);
        }
        
      } catch (error) {
        console.error('Error adding to cart:', error);
        if (submitButton) {
          submitButton.disabled = false;
        }
      }
    });

    // Handle quantity changes
    const quantityInput = form.querySelector('.product-card-detailed__quantity-input');
    const minusButton = form.querySelector('.product-card-detailed__quantity-button:first-child');
    const plusButton = form.querySelector('.product-card-detailed__quantity-button:last-child');

    if (minusButton && plusButton && quantityInput) {
      minusButton.addEventListener('click', () => {
        const newValue = Math.max(1, parseInt(quantityInput.value) - 1);
        quantityInput.value = newValue;
      });

      plusButton.addEventListener('click', () => {
        const newValue = parseInt(quantityInput.value) + 1;
        quantityInput.value = newValue;
      });
    }
  });
}); 